import ajax from '@/libs/Ajax'

const nameSpace = '/aseapi/console/systemmgr'

export default {
  select(param) {
    return ajax.get(`${nameSpace}/monitorinfomgr/resinfolists`, {
      params: param
    })
  },
  start(uuid) {
    return ajax.get(`${nameSpace}/monitorinfomgr/startres`, {
      params: {
        uuid: uuid
      }
    })
  },
  stop(uuid) {
    return ajax.get(`${nameSpace}/monitorinfomgr/stopres`, {
      params: {
        uuid: uuid
      }
    })
  },
  startAll() {
    return ajax.get(`${nameSpace}/monitorinfomgr/startall`)
  },
  stopAll() {
    return ajax.get(`${nameSpace}/monitorinfomgr/stopall`)
  },
  check(uuid) {
    return ajax.get(`${nameSpace}/monitorinfomgr/flewChart`, {
      params: {
        uuid: uuid
      }
    })
  },
  queryInfo(idconfuuid, sptype) {
    return ajax.get(`${nameSpace}/monitorinfomgr/queryInfo`, {
      params: {
        idconfuuid: idconfuuid,
        sptype: sptype
      }
    })
  }
}